import Repo from './Repo.js'

export default class ProductSizeRepository extends Repo {
  constructor () {
    super('product-sizes')
  }

  all (q, include) {
    return super.all(q, {include: include})
  }

  store (data) {
    return super.store(data)
  }

  update (id, data) {
    return super.update(id, data)
  }

  get (id, include) {
    return super.get(id, {include: include})
  }

  delete (id) {
    return super.delete(id)
  }

  paginate (q, include) {
    return super.paginate(q, include)
  }

  getUsers(id, include, data) {
    if(data) {
      data.orderBy = 'created_at,desc';
    }
    if(include) {
      data.include = include
    }
    return this.http.get(this.resource + '/' + id + '/users', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  attachUser(id, user_id){
    return this.http.post(this.resource + '/' + id + '/users/' + user_id).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  detachUser(id, user_id){
    return this.http.delete(this.resource + '/' + id + '/users/' + user_id).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }
}
